import { format, parseISO } from "date-fns";
import { useParams } from "react-router-dom";

import { useGetBillingNoteExport } from "~/providers/hooks";
import { getFullName } from "~/providers/utils";
import { ReimbursementExportDocument } from "../ReimbursementExport/ReimbursementExportDocument";
import { PdfDownloadLink } from "../shared/PdfDownloadLink";

export const BillingNoteExportDownloadLink = () => {
  const { patientId, sessionId } = useParams();

  const { data, isLoading } = useGetBillingNoteExport({
    patientId: patientId ?? "",
    sessionId: sessionId ?? "",
  });

  if (isLoading || !data) return null;

  const patientName = getFullName(data.patient.name, data.patient.last_name);
  const completedAt = data.completedAt
    ? format(parseISO(data.completedAt), `MM_d_yyyy`)
    : "";

  return (
    <PdfDownloadLink
      document={<ReimbursementExportDocument data={data} />}
      fileName={`Psychiatric consultation - ${patientName} - ${completedAt}.pdf`}
    />
  );
};
